import { FormProps } from '@omilia/chat-ui';
import {
  Notifications,
  ChatResponder,
  Feedback,
  ReopenMinimiziedChat,
  ReopenMinimizedChatState,
} from 'types';

interface initialStateInterface {
  token: string;
  apiUrlDomain: string;
  config: {
    enableResetButton: boolean;
    dataPersistent: boolean;
    enableConsecutiveDialogs: boolean;
    shouldReopenMinimizedChat: ReopenMinimiziedChat;
    title?: string;
    welcomeForm: FormProps | null;
    notifications?: Notifications;
    feedback?: Feedback;
    agent?: ChatResponder;
    bot?: ChatResponder;
    previewMode?: boolean;
    enableTransferDisableInput: boolean;
  };
  isMutedSound?: boolean;
  persistentData?: Record<string, any>;
}

const initialState: initialStateInterface = {
  token: '',
  apiUrlDomain: '',
  config: {
    enableResetButton: false,
    dataPersistent: false,
    enableConsecutiveDialogs: true,
    enableTransferDisableInput: true,
    shouldReopenMinimizedChat: ReopenMinimizedChatState.NEXT_TABS,
    title: '',
    welcomeForm: null,
    notifications: {
      withPulseEffect: false,
      withBubble: false,
      withNumber: true,
      withTitle: false,
      withSound: false,
      audioSrc: null,
    },
    agent: {
      name: '',
      withName: false,
      avatar: '',
    },
    bot: {
      name: '',
      withName: false,
      avatar: '',
    },
  },
  isMutedSound: false,
  persistentData: null,
};

export default initialState;
